const useFreshchat = () => {
  const updateFreshchatUser = () => {
    console.log('useFreshchat :: web platform is not supported yet')
  }

  const showConversations = () => {
    console.log('useFreshchat :: web platform is not supported yet')
  }

  return { updateFreshchatUser, showConversations }
}

export { useFreshchat }
